@if (rows().length) {
  <section class="summary" aria-label="Gates · valores internos">
    <h3 class="summary__title">Gates · valores internos</h3>
    <ul class="summary__list">
      @for (gate of rows(); track gate.key) {
        <li class="summary__row">
          <span class="summary__label">
            {{ labelOf(gate) }}
            <strong class="summary__value">{{ describeValue(gate) }}</strong>
          </span>
          <span class="gate-tag" [class]="'gate-tag gate-tag--' + gate.result">
            <i class="pi" [class]="'pi ' + labels[gate.result].icon" aria-hidden="true"></i>
            {{ labels[gate.result].text }}
          </span>
        </li>
      }
    </ul>
  </section>
}
